import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import { PROPS_CLASSES } from './constants';
import useImageResolution, {
  type CustomResolutionsRecord,
} from '../../../composables/useImageResolution';
import { APP_IMAGE_BREAKPOINTS } from '../../../composables/constants';
import { useCdnImg } from '@webplatform/cdn-image';

interface Image {
  src: string;
  width?: number | null;
  height?: number | null;
  alt?: string | null;
}

interface Props {
  image?: {
    src?: string | null;
    desktop?: Image | null;
    tablet?: Image | null;
    mobile?: Image | null;
    alt?: string | null;
  } | null;
  imageFit?: keyof typeof PROPS_CLASSES.imageFit | null;
  alt?: string | null;
}

interface Breakpoints {
  mobile: number;
  tablet: number;
  desktop: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbImage',
  props: {
    image: null,
    imageFit: null,
    alt: null
  },
  setup(__props: any) {

const props = __props as {
  image?: {
    src?: string | null;
    desktop?: Image | null;
    tablet?: Image | null;
    mobile?: Image | null;
    alt?: string | null;
  } | null;
  imageFit?: keyof typeof PROPS_CLASSES.imageFit | null;
  alt?: string | null;
};

const DEFAULT_ALT = '';
const DEFAULT_IMAGE_FIT = 'cover';



const customResolutionsRecord = computed<CustomResolutionsRecord>(() => {
  return {
    desktop: {
      width: props.image?.desktop?.width,
      height: props.image?.desktop?.height,
    },
    tablet: {
      width: props.image?.tablet?.width,
      height: props.image?.tablet?.height,
    },
    mobile: {
      width: props.image?.mobile?.width,
      height: props.image?.mobile?.height,
    },
  };
});

const { isTablet, isDesktop, imageResolution } = useImageResolution(
  customResolutionsRecord.value,
);

const breakpoints: Breakpoints = APP_IMAGE_BREAKPOINTS;
const { generateUrl } = useCdnImg();

const classes = computed(() => [
  PROPS_CLASSES.imageFit[props.imageFit ?? DEFAULT_IMAGE_FIT],
]);
const hasImage = (breakpoint: keyof typeof APP_IMAGE_BREAKPOINTS) =>
  props.image?.[breakpoint]?.src;

const fallbackImage = computed(() => {
  const breakpoint =
    Object.entries(breakpoints).find(
      ([name]) => props.image?.[name as keyof typeof APP_IMAGE_BREAKPOINTS],
    )?.[0] ?? 'desktop';
  let image;

  if (!breakpoint) image = props.image;
  else if (isDesktop.value)
    image =
      props.image?.desktop && props.image.desktop.src
        ? props.image.desktop
        : props.image;
  else if (isTablet.value)
    image =
      props.image?.tablet && props.image.tablet.src
        ? props.image.tablet
        : props.image;
  else
    image =
      props.image?.mobile && props.image.mobile?.src
        ? props.image.mobile
        : props.image;

  const width =
    breakpoints[(breakpoint as keyof typeof breakpoints) ?? 'desktop'];
  const height = 'auto';

  return {
    src: image?.src,
    alt: props.image?.alt ?? DEFAULT_ALT,
    width,
    height,
  };
});

const imageAspectRatio = computed(
  () => `${imageResolution.value.width}/${imageResolution.value.height}`,
);

return { __sfc: true,DEFAULT_ALT, DEFAULT_IMAGE_FIT, props, customResolutionsRecord, isTablet, isDesktop, imageResolution, breakpoints, generateUrl, classes, hasImage, fallbackImage, imageAspectRatio }
}

})